<template>
  <v-card>
    <v-toolbar style="display: block">
      <v-btn icon @click="GoBack">
        <v-icon>close</v-icon>
      </v-btn>
      <div
        style="
          display: grid;
          align-items: center;
          column-gap: 10px;
          grid-template-columns: 1fr 1fr;
          width: 100%;
        "
      >
        <slot name="title"></slot>
        <div style="display: flex; justify-self: flex-end; align-items: center">
          <span>Рейтинг:</span>
          <v-rating
            :value="rate"
            color="yellow darken-3"
            background-color="grey darken-1"
            empty-icon="$ratingFull"
            half-increments
            hover
            class="rating_star noHover rating__off"
            rating__off
            disabled
          />
          ({{ count }})
        </div>
      </div>
    </v-toolbar>
    <div>
      <h3 class="pl-4 pt-4 pb-4 pr-4">
        Моя оценка и комментарий
        <v-icon
          color="green darken-2"
          v-if="!showDopParams"
          @click="showDopParams = !showDopParams"
        >
          mdi-chevron-down
        </v-icon>
        <v-icon
          color="green darken-2"
          v-if="showDopParams"
          @click="showDopParams = !showDopParams"
        >
          mdi-chevron-up
        </v-icon>
      </h3>
      <div v-if="showDopParams">
        <div
          style="display: flex; flex-wrap: wrap; justify-content: space-between"
          v-if="this.userInfo"
        >
          <SliderWrapper v-if="googAndBadFirstColumn.length">
            <Slider
              v-for="(item, index) in googAndBadFirstColumn"
              :title="item.name"
              v-model="item.value"
              :key="index"
            />
          </SliderWrapper>
          <SliderWrapper v-if="googAndBadSecondColumn.length">
            <Slider
              v-for="(item, index) in googAndBadSecondColumn"
              :title="item.name"
              v-model="item.value"
              :key="index"
            />
          </SliderWrapper>
        </div>
        <div class="flex" style="justify-content: space-between;">
          <Recommend v-model="userInfo.recommend" />
          <div class="rates">
            <h3>Ваша оценка*</h3>
            <v-rating
              v-model="userInfo.rate"
              color="yellow darken-3"
              :background-color="rateBG"
              empty-icon="$ratingFull"
              half-increments
              hover
              class="rating_star"
            />

            <span
              style="color: red; font-size: 13px; position: absolute; top: 40px"
              v-if="rateBG === 'red lighten-2'"
              >Ваша оценка обязательна</span
            >
          </div>
        </div>

        <v-card-text>
          <v-textarea
            append-icon="mdi-close"
            @click:append="$emit('clearGood')"
            type="text"
            label="Плюсы. Максимально 1000 символов"
            v-model="userInfo.good"
            outlined
            :rows="3"
          />
          <v-textarea
            append-icon="mdi-close"
            @click:append="$emit('clearBad')"
            type="text"
            label="Минусы. Максимально 1000 символов"
            v-model="userInfo.bad"
            outlined
            :rows="3"
          />

          <v-textarea
            :rules="comentrules"
            append-icon="mdi-close"
            @click:append="$emit('clearComment')"
            type="text"
            label="Комментарий* От 10 до 1000 символов"
            v-model="userInfo.comment"
            outlined
            :rows="3"
            :error="commentError"
            error-messages="Поле должно быть заполнено и быть больше 10 и менее 1000 символов"
          />
          <!-- :error-messages="commentMessage" -->
        </v-card-text>
      </div>
      <v-card-actions v-if="HaveChanges">
        <div class="actions">
          <div class="error__message">
            При изменении комментария полученные лайки/дизлайки исчезнут
          </div>
          <div class="buttons__group">
            <v-btn
              @click="$emit('cancelChanges')"
              color="error"
              title="Отменить все изменения"
              >Отменить</v-btn
            >
            <v-btn
              @click="saveRating"
              color="success"
              title="Сохранить изменения"
              >Сохранить</v-btn
            >
          </div>
        </div>
      </v-card-actions>
    </div>
  </v-card>
</template>
<script>
import moment from "moment";
import { roleObj } from "@/plugins/roles";
import SliderWrapper from "./SliderWrapper.vue";
import Slider from "./Slider.vue";
import Recommend from "./Recommend.vue";

export default {
  name: "user_rating",
  components: { Slider, SliderWrapper, Recommend },
  data: () => ({
    comentrules: [
      (e) =>
        (!!e && e.length > 10 && e.length < 1000) ||
        "Поле должно быть заполнено и быть больше 10 и менее 1000 символов",
    ],
    showDopParams: false,
    moment,
    roleObj,
    commentError: false,
    rateError: false,
  }),
  props: {
    userInfo: {
      type: Object,
      required: true,
    },
    rate: { type: Number, default: 0 },
    count: { type: Number },
    site_name: { type: String, default: "" },
    HaveChanges: { type: Boolean, default: false },
  },
  computed: {
    rateBG() {
      return !this.rateError
        ? "grey darken-1"
        : this.userInfo.rate === 0
        ? "red lighten-2"
        : "grey darken-1";
    },
    googAndBadFirstColumn() {
      if (this.userInfo && this.userInfo.goodOrBad !== undefined) {
        const second = this.userInfo.goodOrBad.length / 2;
        return this.userInfo.goodOrBad.slice(0, second);
      }

      return [];
    },
    googAndBadSecondColumn() {
      if (this.userInfo && this.userInfo.goodOrBad !== undefined) {
        const first = this.userInfo.goodOrBad.length / 2;
        return this.userInfo.goodOrBad.slice(
          first,
          this.userInfo.goodOrBad.length
        );
      }
      return [];
    },
    ValidSave() {
      return this.userInfo.comment.length > 1000 ? true : false;
    },
    site_id() {
      return this.$store.getters.get_site_id;
    },
  },
  methods: {
    saveRating() {
      if (this.userInfo.rate === 0) {
        this.rateError = true;
        return;
      }
      if (
        this.userInfo.comment.length < 10 ||
        this.userInfo.comment.length > 1000
      ) {
        this.commentError = true;
        return;
      }

      this.rateError = false;
      this.commentError = false;
      this.$emit("saveRating");
    },
    GoBack() {
      this.$router.push("/rating");
    },
  },
  mounted(){
    this.$route.query.dop === 'true' && (this.showDopParams = true)
  }
  // watch: {
  //   rateRemove() {
  //     this.rateRemove && this.commentRemove && this.$emit('removeComment');
  //   },
  //   commentRemove() {
  //     this.rateRemove && this.commentRemove && this.$emit('removeComment');
  //   },
  // },
};
</script>
<style lang="sass" scoped>
.rates
  display: flex
  padding: 10px 20px
  font-size: 15px
  align-items: center
  justify-content: flex-end
  position: relative

.actions
  width: 100%
  display: grid
  grid-template-columns: 4fr 1fr
  align-items: center
.error__message
  display: block
  display: block
  color: red
  text-align: center

.buttons__group
  display: flex
  flex-wrap: nowrap
  justify-content: flex-end
</style>
